export default __webpack_public_path__ + "0d59058a67c9f7dc0d2f4142f62eab1d.svg";